const Electrical = () => {
  return <h1>Electrical</h1>;
};

export default Electrical;
